import styled from 'styled-components';

import Icon from 'components/Icon';

export const StyledButton = styled.button`
  border-width: 1px 1px 0px 1px;
  border-style: solid;
  border-color: #ececec;
  border-radius: 4px 4px 0px 0px;
  font-family: 'Lato';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  cursor: ${({checkEscalated}) => (checkEscalated ? '' : 'pointer')};
  background-color: ${({checkEscalated}) => (checkEscalated ? '#FDD1D1' : ' #FFFFFF')};
  color: ${({checkEscalated}) => (checkEscalated ? '#F31414' : '#757575')};
  padding: 0 10px;

  width: ${({isMobile}) => (isMobile ? '' : '159px')};
  height: ${({isMobile}) => (isMobile ? '32px' : '40px')};
  align-self: flex-end;
`;

export const EscalationIcon = styled(Icon).attrs({
  name: 'report-issue'
})`
  height: ${({isMobile}) => (isMobile ? '19px' : '20px')};
  width: ${({isMobile}) => (isMobile ? '17px' : '20px')};
  margin-right: ${({isMobile}) => (isMobile ? '5px' : '10px')};
  margin-bottom: ${({isMobile}) => (isMobile ? '4px' : '3px')};
`;

export const StyledDiv = styled.div`
  font-family: 'Lato';
  font-style: normal;
  font-weight: 400;
  font-size: ${({isMobile}) => (isMobile ? '14px' : '16px')};
  line-height: 24px;
  display: inline;
`;
